module.exports = __webpack_public_path__ + "img/ics_o_pos.6d317955.svg";